import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '@boma/app-config';
import { map, Observable } from 'rxjs';
import { ItemClassification } from '@boma/supplier-portal/shared/entities';

@Injectable({
  providedIn: 'root',
})
export class ItemClassificationsService {
  private base: string;
  private version: string;

  constructor(
    @Inject(APP_CONFIG) private configuration: any,
    private httpClient: HttpClient
  ) {
    this.base = configuration.apiRoute;
    this.version = configuration.apiVersion;
  }

  searchItemClassificationCodes(
    entityId: string,
    searchTerm: string
  ): Observable<ItemClassification[]> {
    return this.httpClient
      .get<ItemClassification[]>(
        `${this.base}api/v${this.version}/${entityId}/ZraItemClassifications/search`,
        {
          params: { searchTerm },
        }
      )
      .pipe(
        map((response) => response.map((item) => new ItemClassification(item)))
      );
  }
}
